export default {
  cake: {
    56: '0xF952Fc3ca7325Cc27D15885d37117676d25BfdA6',
    97: '0xF952Fc3ca7325Cc27D15885d37117676d25BfdA6',
  },
  masterChef: {
    56: '0xe70E9185F5ea7Ba3C5d63705784D8563017f2E57',
    97: '0xe70E9185F5ea7Ba3C5d63705784D8563017f2E57',
  },
  wbnb: {
    56: '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c',
    97: '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c',
  },
  lottery: {
    56: '',
    97: '',
  },
  lotteryNFT: {
    56: '',
    97: '',
  },
  mulltiCall: {
    56: '0x1ee38d535d541c55c9dae27b12edf090c608e6fb',
    97: '0x67ADCB4dF3931b0C5Da724058ADC2174a9844412',
  },
  busd: {
    56: '0xe9e7cea3dedca5984780bafc599bd69add087d56',
    97: '0xe9e7cea3dedca5984780bafc599bd69add087d56',
  },
  refferal: {
    56: '0x04341f9b0b8CDB294FE0A3CC34f6930c4E3665C1',
    97: '0x08d49215Be16bd8593c046119A5631Ec668AB99b',
  },
}
